import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClient } from "../../tools/api-client";
import { AddNursesResponse, Hospital } from "./add-nurses";

@Injectable()
export class AddNursesService {
  constructor(private apiClient: ApiClient) {}

  getHospitals(name: string): Observable<Hospital[]> {
    return this.apiClient.get<Hospital[]>("/api/hospitals", { name });
  }

  addNurses(hospital: string, emails: string[], language: string): Observable<AddNursesResponse> {
    return this.apiClient.post<AddNursesResponse>("/api/admin/nurses", { hospital, emails, language });
  }
}
